const Space = {
  props: ['pwidth', 'pheight', 'pcolor'],
  render(h) {
    return h('div', {
      class: 'Space',
      style: {
        '--color': this.pcolor,
        height: this.pheight,
        width: this.pwidth,
      },
    });
  },
  data() {
    return { width: null, height: null, color: null };
  },
  created() {
    this.width = this.pwidth;
    this.height = this.pwidth;
    this.color = this.pcolor;
  },
};

export default Space;
